export default __webpack_public_path__ + "static/media/Walk (5).0361380d.png";